import { Headers } from '@egw/components'
import { AllocationHoldingsList } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsAllocationHoldingsListPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <AllocationHoldingsList />
    </Layout>
  )
}
